import React from 'react'
import { useSurveyStore } from '../../surveyutilities/surveyStore'
import {Box,IconButton} from '@mui/material'
import {
    KeyboardArrowUp,
  KeyboardArrowDown,
  Delete,
  Add,
  Remove,
  DragIndicator,
  Upload
} from '@mui/icons-material';
function BlockControls({block, isFirst,isLast}) {
    const {moveQuestion,removeQuestion} = useSurveyStore();
    console.log("BLock Control updating")
return (
     <Box
      sx={{
        position: 'absolute',
        left: -30,
        top: 8,
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        opacity: 0.8,
        transition: 'opacity 0.2s'
      }}
    >
      <IconButton
        size="small"
        onClick={() => moveQuestion(block.internalId,'up')}
        disabled={isFirst}
        sx={{ 
          bgcolor: 'white', 
          boxShadow: 1,
          '&:hover': { bgcolor: 'grey.100' }
        }}
      >
        <KeyboardArrowUp fontSize="small" />
      </IconButton>
      
      <IconButton
        size="small"
        onClick={() => moveQuestion(block.internalId,'down')}
        disabled={isLast}
        sx={{ 
          bgcolor: 'white', 
          boxShadow: 1,
          '&:hover': { bgcolor: 'grey.100' }
        }}
      >
        <KeyboardArrowDown fontSize="small" />
      </IconButton>
      
      <IconButton
        size="small"
        onClick={() => removeQuestion(block.internalId)}
        sx={{ 
          bgcolor: 'white', 
          boxShadow: 1,
          color: 'error.main',
          '&:hover': { bgcolor: 'error.50' }
        }}
      >
        <Delete fontSize="small" />
      </IconButton>
    </Box>
  )
}

export default BlockControls